import { FiasResponse, FiasSearchParams } from "../types/api/fiasAPI";
import { AxiosResponse } from "axios";
import { $apiDadata } from "../axios";

export const doPostRequest = (
    query: string,
    from_bound?: {
        value: string;
    },
    to_bound?: {
        value: string;
    },
    locations?: Array<Record<string, string>>,
    callback?: (resp: any) => void,
    errorCallback?: (resp: any) => void,
    searchParams?: Record<string, any>,
): Promise<AxiosResponse<any>> => {
    return $apiDadata
        .post<any>("address", { query, from_bound, to_bound, locations })
        .then(response => {
            return response.data;
        })
        .then((data: any) => {
            return callback ? callback(data) : data;
        })
        .catch((err: any) => (errorCallback ? errorCallback(err.response.data) : Promise.reject(err.response.data)));
};

export const getLocality = (
    query: string,
    from_bound?: {
        value: string;
    },
    to_bound?: {
        value: string;
    },
    locations?: Array<Record<string, string>>,
    callback?: (resp: FiasResponse) => any,
    errorCallback?: (resp: any) => void,
    searchParams?: FiasSearchParams,
) => {
    return doPostRequest(query, from_bound, to_bound, locations, callback, errorCallback);
};
